export const MAP_VIEW_ORDERS = 'orders';
export const MAP_VIEW_TRANSPORTERS = 'transporters';

export const MAP_VIEW_ROUTES = 'routes';

export const ORDER_VIEW_ROUTES = 'routes';
export const ORDER_VIEW_UNPLANNED_ORDERS = 'unplanned_orders';
